/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ServiceAccountDetails {
    getFixupPrototypeFunction() { return ServiceAccountDetails.fixupPrototype; }

    static newInstance(model: Partial<ServiceAccountDetails>): ServiceAccountDetails {
        let obj = Object.assign(new ServiceAccountDetails(), model);
        ServiceAccountDetails.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ServiceAccountDetails>): ServiceAccountDetails {
        if (!model) return null;
        return ServiceAccountDetails.newInstance(<ServiceAccountDetails> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ServiceAccountDetails) {
        if (!obj) return;

        models.ServiceAccountDetails.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ServiceAccountDetails): boolean {
        Object.setPrototypeOf(obj, ServiceAccountDetails.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (typeof this.created_at === "string") {
            this.created_at = new Date(<string><any>this.created_at);
        }
        if (typeof this.updated_at === "string") {
            this.updated_at = new Date(<string><any>this.updated_at);
        }
        if (this.native_details) {
            models.ServiceAccountNativeDetailsBase.fixupPrototype(this.native_details);
        }
        if (this.credentials) {
            models.ServiceAccountCredentialsBase.fixupPrototype(this.credentials);
        }
        if (this.credentials_temp) {
            models.ServiceAccountCredentialsBase.fixupPrototype(this.credentials_temp);
        }
        if (this.assessment_details) {
            models.ServiceAccountAssessmentDetails.fixupPrototype(this.assessment_details);
        }
        if (this.governance_configuration) {
            models.GovernanceConfiguration.fixupPrototype(this.governance_configuration);
        }
        if (this.onboarded_features) {
            for (let val of this.onboarded_features) {
                models.ServiceAccountFeatureDetails.fixupPrototype(val);
            }
        }
        if (this.custom_tags) {
            for (let val of this.custom_tags) {
                models.KeyValuePairKind.fixupPrototype(val);
            }
        }
    }

    /**
     * Name of the user who created the account.
     */
    created_by: string;

    /**
     * Account creation timestamp
     */
    created_at: Date;

    /**
     * Name of the user who recently updated the account.
     */
    updated_by: string;

    /**
     * Account last updated timestamp.
     */
    updated_at: Date;

    /**
     * Parent account of the account.
     */
    parent_id: string;

    /**
     * Source account id in case of created from associated accounts.
     */
    source_account_id: string;

    /**
     * Link to Service Account that is used to retrieve billing information.
     */
    billing_account_id: string;

    /**
     * Reference to the Service Account under which the resource is provisioned.
     */
    resource_service_account_id: string;

    /**
     * Tenant Id. This is a required field.
     */
    tenant_id: string;

    /**
     * Name of the account. This is a required field.
     */
    name: string;

    /**
     * A brief description of the account.
     */
    description: string;

    /**
     * Billing currency of the account.
     */
    currency: models.Currency;

    /**
     * If set, the account will be used in self service for its tenant.
     */
    use_in_self_service: boolean;

    /**
     * Indicates the status of the account. This is a required field.
     */
    status: models.ServiceAccountStatus;

    /**
     * Id of the keystone tenant for mistral template executions.
     */
    keystone_tenant_id: string;

    /**
     * Scope of the account. This is a required field.
     */
    scope: models.ServiceAccountScope;

    /**
     * Type of the onboarding. This is a required field.
     */
    onboarding_type: models.ServiceAccountOnboardingType;

    onboarded_features: Array<models.ServiceAccountFeatureDetails>;

    /**
     * Native details of the account. This is a required field.
     */
    native_details: models.ServiceAccountNativeDetailsBase;

    /**
     * Authentication credentials of account.
     */
    credentials: models.ServiceAccountCredentialsBase;

    /**
     * Temporary storage for Authentication credentials of account before validation.
     */
    credentials_temp: models.ServiceAccountCredentialsBase;

    /**
     * List of tag key/value and kind
     */
    custom_tags: Array<models.KeyValuePairKind>;

    /**
     * Assessment result of the account.
     */
    assessment_details: models.ServiceAccountAssessmentDetails;

    /**
     * Governance configuration.
     */
    governance_configuration: models.GovernanceConfiguration;

    /**
     * Indicates whether the account is active in the native cloud.
     */
    is_active_in_cloud: boolean = true;

    /**
     * If set, access validation checks will be skipped for this account.
     */
    skip_access_validation: boolean = false;

}
